module.exports = __webpack_public_path__ + "public/img/img-placeholder-app-icon@2x.27fb698f.png";